(function(){
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var all = [].slice.call(document.querySelectorAll('.gd .rv, .gd .ln'));

  function reveal(el,d){ setTimeout(function(){ el.classList.add('in'); }, d||0); }

  /* ---- 数字滚动累加 ---- */
  function countUp(el){
    if(el.dataset.done) return; el.dataset.done='1';
    var target=parseFloat(el.dataset.n), dec=parseInt(el.dataset.dec||'0',10),
        suf=el.dataset.suffix||'', dur=1250, t0=null, guard;
    function finish(){ el.textContent=target.toFixed(dec)+suf; }
    // 隐藏标签页里 rAF 会被完全冻结，直接落终值，避免数字永远停在 0
    if(RM || document.hidden){ finish(); return; }
    guard=setTimeout(finish, dur+400);          // setTimeout 会被节流但仍会触发，作为保底
    function tick(t){
      if(!t0) t0=t;
      var p=Math.min((t-t0)/dur,1), e=1-Math.pow(1-p,3);      // easeOutCubic
      el.textContent=(target*e).toFixed(dec)+suf;
      if(p<1){ requestAnimationFrame(tick); } else { clearTimeout(guard); finish(); }
    }
    requestAnimationFrame(tick);
  }
  /* 2026-09-03：scope 可能是 null。下面第 33 行是
     countIn(document.querySelector('.gd .hero'))——.gd .hero 只有首页有，
     商品页/分类页上这句拿到 null，整段抛 TypeError。
     线上主题不加载本脚本，所以线上看不到；是 B 版皮肤层在全站都引了它才暴露。
     加一道守卫：没有 scope 就什么都不做（本来也没有计数器要跑）。
     首页行为完全不变。 */
  function countIn(scope){ if(!scope) return; scope.querySelectorAll('.gd .cnt').forEach(countUp); }

  if(RM || !('IntersectionObserver' in window)){
    all.forEach(function(e){e.classList.add('in');});
    document.querySelectorAll('.gd .cnt').forEach(countUp);
  } else {
    /* 首屏：载入即按序显现，不依赖滚动 */
    var hero=[].slice.call(document.querySelectorAll('.gd .hero .rv, .gd .hero .ln'));
    hero.forEach(function(el,i){ reveal(el, 120+i*95); });
    setTimeout(function(){ countIn(document.querySelector('.gd .hero')); }, 620);

    var io=new IntersectionObserver(function(es){
      es.forEach(function(e,i){
        if(!e.isIntersecting) return;
        reveal(e.target, Math.min(i,6)*70);
        if(e.target.querySelectorAll) setTimeout(function(){ countIn(e.target); }, 260);
        io.unobserve(e.target);
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:.06});
    all.forEach(function(el){ if(hero.indexOf(el)===-1) io.observe(el); });

    /* 保底：加载后 2.5s，仍在视口内却没显现的强制显示 */
    window.addEventListener('load',function(){ setTimeout(function(){
      all.forEach(function(el){
        if(el.classList.contains('in')) return;
        var r=el.getBoundingClientRect();
        if(r.top<innerHeight && r.bottom>0){ el.classList.add('in'); countIn(el); }
      });
    },2500); });

    /* 看门狗：上面那条只管「.in 没加上」，管不了「.in 加上了、过渡却不推进」。
       后者更危险——首屏 H1 用的是 .ln 遮罩，<i> 卡在 translateY(108%) 上
       而 .ln 是 overflow:hidden，等于整个大标题不可见。
       实测：本页 18 组遮罩标题（含首屏那 2 组）在不出帧的环境里全部停在起始态。

       处理方式是【逐条取消卡住的那个 Animation】，不是关掉元素上的所有过渡。
       元素此刻已经带着 .in，它的指定值就是终态（opacity:1 / transform:none），
       过渡一取消就直接落到指定值，连 !important 都不需要，
       hover 的颜色和位移过渡也不会被误伤。
       （这套做法来自版式 D，是并行的橙色版会话给出的更精准写法。） */
    setTimeout(function(){
      var stuck=[].slice.call(document.querySelectorAll('.gd .ln.in > i, .gd .in .ln > i'))
        .filter(function(i){
          var t=getComputedStyle(i).transform;
          return t && t!=='none' && t!=='matrix(1, 0, 0, 1, 0, 0)';
        });
      if(!stuck.length){
        stuck=all.filter(function(el){
          if(!el.classList.contains('in')) return false;
          var r=el.getBoundingClientRect();
          if(!r.height || r.top>innerHeight || r.bottom<0) return false;
          return parseFloat(getComputedStyle(el).opacity)<0.95;
        });
      }
      if(!stuck.length) return;

      var targets=all.slice();
      [].push.apply(targets,[].slice.call(document.querySelectorAll('.gd .ln > i')));
      var handled=true;
      targets.forEach(function(el){
        if(!el.getAnimations){ handled=false; return; }
        el.getAnimations().forEach(function(a){
          var p=a.transitionProperty;
          if(p==='opacity'||p==='transform'){ try{ a.cancel(); }catch(e){ handled=false; } }
        });
      });
      /* getAnimations 支持面 Chrome 84+ / Safari 13.1+ / Firefox 75+，
         比这份 CSS 已经在用的 aspect-ratio 还宽，正常走不到这一支。 */
      if(!handled){
        document.querySelectorAll('.gd .rv, .gd .ln > i').forEach(function(el){
          el.style.transition='none'; el.style.opacity='1'; el.style.transform='none';
        });
      }
    },2000);
  }

  /* 从后台切回前台时，补齐任何仍停在初值的数字 */
  document.addEventListener('visibilitychange',function(){
    if(document.hidden) return;
    document.querySelectorAll('.gd .cnt').forEach(function(el){
      if(el.dataset.done && el.textContent==='0'){
        var t=parseFloat(el.dataset.n), d=parseInt(el.dataset.dec||'0',10);
        el.textContent=t.toFixed(d)+(el.dataset.suffix||'');
      }
    });
  });


  /* ---- 热销轨道：左右按钮 ----
     按钮只是辅助。触屏原生滑动、鼠标横向滚轮、键盘 Tab 逐个聚焦卡片
     本来就能推动轨道，所以这段 JS 挂了也不影响浏览，只是少两个按钮可点。 */
  document.querySelectorAll('.gd [data-sg-rail]').forEach(function(rail){
    /* 三条查找路径的 logo 轨道和热销轨道共用这一段。
       箭头不一定是轨道的兄弟节点（路径段里它在上方的标题行里），
       所以先在同一个 section 内找，找不到再退回兄弟节点。 */
    var scope=rail.closest('section, .gd-sec') || rail.parentElement;
    var nav=scope.querySelector('[data-sg-nav]') || rail.parentElement.querySelector('[data-sg-nav]');
    if(!nav) return;
    var prev=nav.querySelector('[data-sg-prev]'), next=nav.querySelector('[data-sg-next]');

    /* 一次翻「看得见的整数张卡」，不是固定像素：卡片宽度是 clamp()，
       写死像素在窄屏上会翻过头、宽屏上又翻不够一屏。

       卡片和间距都从轨道自己读，不写死类名：这段现在同时服务
       热销轨道（.sgc / gap 14px）和三条路径的 logo 轨道（.pth__mark / gap 1px）。
       之前写死 '.sgc' 和 14 的话，路径轨道会取不到卡片、退回按整屏翻。 */
    function step(){
      var card=rail.firstElementChild;
      if(!card) return rail.clientWidth;
      var gap=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap||0)||0;
      var w=card.getBoundingClientRect().width+gap;
      var n=Math.max(1,Math.floor(rail.clientWidth/w));
      return w*n;
    }
    function sync(){
      var max=rail.scrollWidth-rail.clientWidth;
      // 留 2px 容差：不同缩放比例下 scrollLeft 会有小数，严格比较会让按钮在到头时闪
      prev.disabled = rail.scrollLeft<=2;
      next.disabled = rail.scrollLeft>=max-2;
    }
    prev.addEventListener('click',function(){ rail.scrollBy({left:-step(),behavior:'smooth'}); });
    next.addEventListener('click',function(){ rail.scrollBy({left: step(),behavior:'smooth'}); });
    rail.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    sync();
  });

  /* ---- logo 轨道的即时筛选 ----
     全部品牌/车系都铺出来之后（32 个设备品牌、79 个车系），
     「找到 Toyota」变成了体力活：横滑要划过近 6000px。
     打两个字母比划六千像素快得多。

     几条刻意的选择：
       · 输入框由 JS 插入，不写在 Liquid 里。没有 JS 时不该留一个
         打了字没反应的死控件——轨道本身照样能滑、能 Tab、能点。
       · 纯前端过滤。所有条目本来就已经在 DOM 里了，不发请求也不刷新。
       · 用 hidden 属性而不是 display:none 的 class：hidden 会同时
         把元素移出无障碍树，屏幕阅读器不会念出被过滤掉的项。
       · 过滤后把 scrollLeft 归零。命中项可能在第 30 列，
         不归零的话用户看到的是一片空白，会以为搜不到。 */
  document.querySelectorAll('.gd [data-pth-filter]').forEach(function(host){
    var scope = host.closest('section, .gd-sec');
    var rail  = scope && scope.querySelector('[data-sg-rail]');
    if (!rail) return;
    var marks = [].slice.call(rail.querySelectorAll('.pth__mark'));
    if (marks.length < 8) return;          // 条目少到一眼扫得完，就不加控件

    /* 名字取一次存起来，不在每次按键时读 DOM */
    var names = marks.map(function(m){
      var s = m.querySelector('span');
      return (s ? s.textContent : '').toLowerCase().trim();
    });

    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'pth__fi';
    input.placeholder = (host.getAttribute('data-placeholder') || 'Filter') + ' ' + marks.length;
    input.setAttribute('aria-label', input.placeholder);
    var count = document.createElement('span');
    count.className = 'pth__fn';
    /* aria-live：过滤是纯视觉变化，不播报的话屏幕阅读器用户
       打完字完全不知道结果变了 */
    count.setAttribute('aria-live','polite');
    host.appendChild(input);
    host.appendChild(count);

    var emptyMsg = host.getAttribute('data-empty') || 'No match';

    /* ---- 分组按钮 ----
       甲方要求参考顶部导航大菜单的筛选方式。那里是两套：
       车系用「Origin of cars: All / American / European / Asian」，
       设备品牌用「Filter: All / A / B / C … Z」。

       这里按【数据本身】决定用哪套，不写死：
         · 卡片带 data-origin（车系，读 metafields.custom.origin）→ 产地分组
         · 否则按首字母分组（设备品牌）
       两种都【只渲染真实存在的值】。导航那排 A–Z 是把 26 个字母全铺出来的，
       但实测 32 个设备品牌只跨 13 个首字母——铺满等于一半是点了没反应的
       死按钮。这里只出 13 个。 */
    var groupOf, groups = [];
    var hasOrigin = marks.some(function(m){ return m.getAttribute('data-origin'); });
    if (hasOrigin) {
      groupOf = function(m){ return m.getAttribute('data-origin') || ''; };
    } else {
      groupOf = function(m, i){ return (names[i].charAt(0) || '').toUpperCase(); };
    }
    var keys = marks.map(groupOf);
    keys.forEach(function(k){ if (k && groups.indexOf(k) < 0) groups.push(k); });
    groups.sort();

    var active = '';
    var pillWrap = null, pills = [];
    if (groups.length > 1) {
      pillWrap = document.createElement('div');
      pillWrap.className = 'pth__pills';
      pillWrap.setAttribute('role','group');
      /* 「All」也是一个按钮，和导航一致——不做成"取消筛选"的叉，
         因为叉只有筛选后才出现，用户看不到退路 */
      [''].concat(groups).forEach(function(g){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pth__pill' + (g === '' ? ' is-on' : '');
        b.textContent = g === '' ? (host.getAttribute('data-all') || 'All') : g;
        b.setAttribute('aria-pressed', g === '' ? 'true' : 'false');
        b.addEventListener('click', function(){
          active = (active === g) ? '' : g;   // 再点一次同一个 = 取消
          apply();
        });
        b._g = g;
        pills.push(b);
        pillWrap.appendChild(b);
      });
      /* 插在轨道前面、band 标题行之外，和导航的版式一致：
         筛选条一整行在上，内容在下 */
      rail.parentNode.insertBefore(pillWrap, rail);
    }

    function apply(){
      var q = input.value.toLowerCase().trim();
      var hit = 0;
      for (var i=0; i<marks.length; i++){
        /* 两个条件是【与】关系：先按分组收窄，再用输入框收窄。
           Asian 有 35 个，光靠分组还是不够快。 */
        var ok = (!q || names[i].indexOf(q) > -1) && (!active || keys[i] === active);
        marks[i].hidden = !ok;
        if (ok) hit++;
      }
      pills.forEach(function(b){
        var on = b._g === active;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var filtering = !!q || !!active;
      host.classList.toggle('is-on', filtering);
      count.textContent = !filtering ? '' : (hit ? hit + ' / ' + marks.length : emptyMsg);
      /* 过滤后回到起点。命中项可能在第 30 列，
         不归零的话用户看到的是一片空白，会以为搜不到。 */
      rail.scrollLeft = 0;
    }

    input.addEventListener('input', apply);
    input.addEventListener('keydown', function(e){
      if (e.key === 'Escape'){ input.value=''; active=''; apply(); }
    });
  });

  /* ---- 光标跟随环 ----
     几条刻意的约束：
       · 不隐藏原生指针。很多站把 cursor 设成 none 换成自绘的点，
         好看但代价是精度和无障碍——这是个要点击 SKU、价格、小箭头的
         专业目录站，指针不能变模糊。这里只是加一层氛围，不替代它。
       · 只在有精确指针的设备上启用（pointer:fine）。触屏没有悬停，
         装了只会白占一个常驻元素。
       · 减弱动效偏好下整个不启用。
       · rAF 只在指针动过之后跑，追上目标就停——常驻的每帧循环
         在一个大量使用 blur 和 filter 的页面上是纯浪费。 */
  (function(){
    if (RM) return;
    if (!(window.matchMedia && matchMedia('(pointer:fine)').matches)) return;

    var dot=document.createElement('div');
    dot.className='gdcur'; dot.setAttribute('aria-hidden','true');
    document.body.appendChild(dot);

    var tx=innerWidth/2, ty=innerHeight/2, x=tx, y=ty, raf=0, shown=false;

    function tick(){
      // 缓动跟随：直接赋值会和原生指针完全重合，看不出是两层
      x += (tx-x)*0.18; y += (ty-y)*0.18;
      dot.style.transform='translate3d('+(x-16)+'px,'+(y-16)+'px,0)';
      if (Math.abs(tx-x)>0.4 || Math.abs(ty-y)>0.4) { raf=requestAnimationFrame(tick); }
      else { raf=0; }                                  // 追上了就停，不常驻空转
    }
    function move(e){
      tx=e.clientX; ty=e.clientY;
      if (!shown){ shown=true; dot.classList.add('on'); }
      if (!raf) raf=requestAnimationFrame(tick);
    }
    addEventListener('mousemove', move, {passive:true});
    addEventListener('mouseout', function(e){
      if (!e.relatedTarget){ shown=false; dot.classList.remove('on'); }
    });

    /* 悬停在可点元素上时放大。用事件委托而不是给每个元素绑监听——
       首页现在有一百多个链接，逐个绑没有必要。 */
    var HIT='a,button,input,select,[role="button"]';
    addEventListener('mouseover', function(e){
      var t=e.target.closest && e.target.closest(HIT);
      dot.classList.toggle('hit', !!t);
    }, {passive:true});
  })();

  /* ---- 查找控制台：标签切换 + 车辆四级 ---- */
  document.querySelectorAll('.gd [data-finder]').forEach(function(fc){
    var tabs=[].slice.call(fc.querySelectorAll('[data-tab]')),
        panels=[].slice.call(fc.querySelectorAll('[data-panel]'));
    function go(name){
      tabs.forEach(function(t){
        var on=t.dataset.tab===name;
        t.classList.toggle('is-on',on); t.setAttribute('aria-selected',String(on));
      });
      panels.forEach(function(p){ p.classList.toggle('is-on',p.dataset.panel===name); });
    }
    tabs.forEach(function(t){ t.addEventListener('click',function(){ go(t.dataset.tab); }); });
    // 键盘左右切换，符合 tablist 无障碍预期
    fc.querySelector('[role="tablist"]').addEventListener('keydown',function(e){
      var i=tabs.indexOf(document.activeElement); if(i<0) return;
      var n = e.key==='ArrowRight' ? i+1 : e.key==='ArrowLeft' ? i-1 : -1;
      if(n<0||n>=tabs.length) return;
      e.preventDefault(); tabs[n].focus(); go(tabs[n].dataset.tab);
    });

    var veh=fc.querySelector('[data-veh]'); if(!veh) return;
    var go2=veh.querySelector('[data-veh-go]'), out=fc.querySelector('[data-veh-out]');
    go2.addEventListener('click',function(){
      var mk=veh.querySelector('[data-veh-make]').value,
          yr=veh.querySelector('[data-veh-year]').value,
          md=veh.querySelector('[data-veh-model]').value,
          sy=veh.querySelector('[data-veh-system]').value;
      if(!mk){ out.classList.remove('on'); return; }
      // 品牌是真实集合，直接落地；年份/车型/系统作为上下文带过去
      var slug=mk.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      var q=[]; if(yr)q.push('v_year='+encodeURIComponent(yr));
      if(md)q.push('v_model='+encodeURIComponent(md));
      if(sy)q.push('v_system='+encodeURIComponent(sy));
      var url='/collections/'+slug+(q.length?'?'+q.join('&'):'');
      var picked=[yr,mk,md].filter(Boolean).join(' ');
      out.innerHTML='<b>&#10003; '+(picked||mk)+'</b>'+
        '<p>'+(sy?sy+' — ':'')+'Showing tools that cover '+mk+'. '+
        '<a href="'+url+'">View tools &rarr;</a></p>';
      out.classList.add('on');
      try{ sessionStorage.setItem('godiagVehicle', JSON.stringify({make:mk,year:yr,model:md,system:sy})); }catch(e){}
    });
  });

  /* ---- 跑马灯与产品墙无缝循环 ---- */
  document.querySelectorAll('.gd [data-marquee]').forEach(function(t){
    if(!t.dataset.dup){ t.dataset.dup='1'; t.innerHTML+=t.innerHTML; }
  });
  document.querySelectorAll('.gd [data-col]').forEach(function(c){ c.innerHTML+=c.innerHTML; });

  /* ---- 滚动驱动的视差 ----
     给 [data-sp] 的元素写一个 CSS 变量 --sp（0→1），表示它穿过视口的进度：
     刚从下方进入是 0，正好居中是 .5，从上方离开是 1。
     JS 只负责算这个数，「拿它做什么」全部交给 CSS——想改视差幅度不用碰 JS。

     为什么不用 CSS 的 animation-timeline:scroll()：Chrome 115+ 有，
     但 Firefox 还在 flag 后面，Safari 直到很近的版本才支持。
     那意味着相当一部分买家什么都看不到，而这条路（scroll 事件 + rAF）
     所有浏览器一致，还能被我在无头环境里驱动 scrollY 验证。

     只在元素接近视口时才计算：整页每帧遍历所有元素是没必要的开销。 */
  var spEls=RM ? [] : [].slice.call(document.querySelectorAll('.gd [data-sp]'));
  /* 初版这里挂了 IntersectionObserver，只给「进入视口的」元素算。
     去掉了：全站只有 2 个 [data-sp] 元素，那点开销根本不值得，
     换来的却是「视差要等 IO 先回调过一次才会动」这条额外的失效路径——
     IO 没回调（后台标签页、无头环境、被节流）时 --sp 永远不写，
     元素停在默认值 .5 上，而且从外面完全看不出是坏了还是本来如此。
     直接遍历 + 一次 rect 粗筛，行为可预测得多。 */
  function paint(){
    for(var i=0;i<spEls.length;i++){
      var el=spEls[i], r=el.getBoundingClientRect();
      if(r.bottom<-innerHeight || r.top>innerHeight*2) continue;   // 离视口太远，不必算
      // 分母用 视口高 + 元素高：元素完整穿过这段距离才算走完 0→1
      var p=(innerHeight-r.top)/(innerHeight+r.height);
      el.style.setProperty('--sp', (p<0?0:p>1?1:p).toFixed(4));
    }
  }

  /* ---- 滚动进度条 ---- */
  var prog=document.getElementById('godiag-prog'), ticking=false;
  function onScroll(){
    var h=document.documentElement.scrollHeight-innerHeight;
    if(prog) prog.style.width=(h>0? (scrollY/h)*100 : 0)+'%';
    paint();
    ticking=false;
  }
  addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(onScroll); ticking=true; } },{passive:true});
  addEventListener('resize',onScroll);
  onScroll();

  /* ---- 车型自查（按 section 实例各自绑定） ---- */
  document.querySelectorAll('.gd [data-fit]').forEach(function(box){
    var go=box.querySelector('[data-fit-go]'), out=box.querySelector('[data-fit-out]'),
        txt=box.querySelector('[data-fit-text]'), base=txt? txt.textContent.trim() : '';
    if(!go||!out||!txt) return;
    go.addEventListener('click',function(){
      var y=box.querySelector('[data-fit-y]').value,
          m=box.querySelector('[data-fit-m]').value,
          d=box.querySelector('[data-fit-d]').value;
      out.classList.remove('on');
      setTimeout(function(){
        txt.textContent=y+' '+m+' '+d+' — '+base;
        out.classList.add('on');
      },140);
    });
  });


  /* ---- 顶栏购物车件数镜像到 data-count ----
     深色皮肤在桌面端把工具区的两行文字收成纯图标，件数改用 CSS ::after
     角标显示。但 ::after 只能读属性，原文件把数字放在子元素
     <span data-yh-cart-count> 里，CSS 取不到，所以在这里镜像一份。
     购物车抽屉加购后主题会改写那个 span，用 MutationObserver 跟随。 */
  (function(){
    var cart=document.querySelector('.yh-tool--cart'); if(!cart) return;
    var src=cart.querySelector('[data-yh-cart-count]'); if(!src) return;
    function sync(){ cart.setAttribute('data-count',(src.textContent||'0').trim()); }
    sync();
    new MutationObserver(sync).observe(src,{childList:true,characterData:true,subtree:true});
  })();
})();

/* =========================================================================
   手机端（9/29 整体重做）：菜单、页脚折叠、两个悬浮按钮不打架
   只做增强：脚本不跑时，菜单照旧能开合、页脚照旧全部展开、按钮照旧在原位。
   样式在 godiag-dark-skin.liquid 的「手机端（9/29 整体重做）」一段。
   ========================================================================= */
(function(){
  var mq = window.matchMedia('(max-width: 768px)');
  var root = document.documentElement;
  function onMq(fn){ if(mq.addEventListener) mq.addEventListener('change', fn); else if(mq.addListener) mq.addListener(fn); }

  /* ---- 菜单：整屏面板 + × ----
     开合本身还是主题原脚本在切 .is-open（yonghui-header.liquid），这里只读结果：
     面板顶边贴页头底边（页头不吸顶，滚过一点再点要按实际位置算）、切 ×、Esc 关闭。 */
  document.querySelectorAll('[data-yh-mobile-toggle]').forEach(function(btn){
    var hdr = btn.closest('.yh'), nav = hdr && hdr.querySelector('[data-yh-nav]');
    if(!nav) return;
    btn.setAttribute('aria-expanded', 'false');
    function sync(){
      var open = nav.classList.contains('is-open') && mq.matches;
      if(open){
        var top = btn.closest('.yh-top') || hdr;
        root.style.setProperty('--yh-menu-top', Math.max(0, Math.round(top.getBoundingClientRect().bottom)) + 'px');
      }
      root.classList.toggle('yh-menu-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    new MutationObserver(sync).observe(nav, { attributes:true, attributeFilter:['class'] });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && nav.classList.contains('is-open')){ nav.classList.remove('is-open'); btn.focus(); }
    });
    onMq(sync);
  });

  /* ---- 页脚：手机上有链接列表的几组折叠，点标题展开；联系方式那组没有列表，不折 ---- */
  [].slice.call(document.querySelectorAll('.yonghui-footer__col')).forEach(function(col, i){
    var h = col.querySelector('.yonghui-footer__heading'), list = col.querySelector('.yonghui-footer__list');
    if(!h || !list) return;
    if(!list.id) list.id = 'yh-foot-list-' + i;
    function apply(){
      if(mq.matches){
        col.classList.add('is-acc');
        h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
        h.setAttribute('aria-controls', list.id);
        h.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
      } else {
        col.classList.remove('is-acc');
        ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function(a){ h.removeAttribute(a); });
      }
    }
    function toggle(){ if(!mq.matches) return; col.classList.toggle('is-open'); apply(); }
    h.addEventListener('click', toggle);
    h.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); } });
    apply(); onMq(apply);
  });

  /* ---- WhatsApp 悬浮球和「Chat」气泡排整齐 ----
     两个都在右下角：WhatsApp 是主题的 .yh-fab，Chat 是 Shopify Inbox 应用的气泡（位置归应用管，
     手机上它在下、距底约 60–90px；电脑上应用设成了「higher」，它在上）。
     9/29 第一版只管「叠上了就把绿球抬到气泡上方 12px」：没叠时各在各的位置，右边缘差 4–6px、上下间距忽大忽小。
     9/29 晚用户：「都留，你距离调整一下」→ 现在不管叠没叠，绿球都贴着气泡排：
       · 右边缘和气泡对齐；
       · 绿球固定排在气泡上面，上下留 GAP。
     气泡我们挪不了（shadow DOM 里的绝对定位，CSS 够不着，见记忆 inbox-position-is-per-theme），所以只挪绿球。
     气泡是后加载的，吸底加购栏出现时绿球还会整体上移，所以前 15 秒定时复查，之后跟着滚动和尺寸变化复查。 */
  var fab = document.querySelector('.yh-fab');
  if(!fab) return;
  var GAP = 18;   /* 3-9：间距从 14 加到 18，两颗球分得更开 */
  function chatRect(){
    var host = document.querySelector('shopify-chat, inbox-online-store-chat');
    var sr = host && host.shadowRoot; if(!sr) return null;
    var a = sr.querySelector('.activator-nudge') || sr.querySelector('.activator') || sr.querySelector('button');
    if(!a) return null;
    var r = a.getBoundingClientRect();
    return (r.width > 0 && r.height > 0) ? r : null;
  }
  function place(){
    var c = chatRect();
    // 先回到主题给的原位再量（吸底栏出现时的 translateY 也包含在量出来的矩形里）
    fab.style.removeProperty('bottom'); fab.style.removeProperty('right');
    var W = document.documentElement.clientWidth;
    if(!c || c.right < W / 2){ return; }            // 没有气泡，或者气泡不在右边：绿球就待在原位
    var f = fab.getBoundingClientRect();
    if(!f.width){ return; }
    var cs = getComputedStyle(fab);
    var b0 = parseFloat(cs.bottom), r0 = parseFloat(cs.right);
    if(isNaN(b0) || isNaN(r0)){ return; }
    // 固定「绿球在上、气泡在下」：绿球底边 = 气泡顶边 − GAP。
    // 不按谁离得近来决定上下——预览模式底部多一条 Shopify 预览条，气泡会被顶高约 68px，
    // 按远近判断的话预览里绿球会跑到气泡下面，和上线后的样子不一致（9/30 截图发现）。
    // 大屏整页放大（html 上的 zoom，见 dark-skin 顶部）时：量出来的矩形是放大后的像素，写回去的 bottom/right 是放大前的——要除回去，否则越放越偏（9/30 晚 3840 下 HKD 叠到 Chat 上）
    var Z = parseFloat(document.documentElement.style.zoom) || 1;
    var want = Math.max(12, Math.round(b0 + (f.bottom - (c.top - GAP * Z)) / Z));
    var right = Math.max(8, Math.round((W - c.right) / Z));  // 右边缘对齐气泡
    fab.style.setProperty('bottom', want + 'px', 'important');
    fab.style.setProperty('right', right + 'px', 'important');

    // 货币切换（Nova，9/29 我们停用、之后甲方又打开了）：电脑上 godiag-bx.css 把它搬到了右下角（左下是旋钮），
    // 它原来固定距底 40px——线上没有预览条时 Chat 会落到它头上。这里把它排进同一列：Chat 下面、同一条右边线、同样 GAP。
    // 手机上它在左下角（插件自己的定位），不动。
    var cur = document.querySelector('.bacurr-cur-block');
    if(cur){
      cur.style.removeProperty('bottom'); cur.style.removeProperty('right');
      var k = cur.getBoundingClientRect(), kb = parseFloat(getComputedStyle(cur).bottom);
      if(k.width && k.left > W / 2 && !isNaN(kb)){
        cur.style.setProperty('bottom', Math.max(12, Math.round(kb + (k.top - (c.bottom + GAP * Z)) / Z)) + 'px', 'important');
        cur.style.setProperty('right', right + 'px', 'important');
      }
    }
  }
  var n = 0, timer = setInterval(function(){ place(); if(++n >= 20) clearInterval(timer); }, 750);
  var st = null;
  addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(place, 180); }, { passive:true });
  addEventListener('resize', place);
})();


/* =========================================================================
   加购后购物车抽屉打不开（9/29 模拟桌面时查出；线上手机、电脑都是这样）
   现象：详情页点「Add to cart」，商品其实加进去了（/cart/add 返回 200），但抽屉不弹、
   页头件数不变——买家看到按钮转一下又恢复原样，以为没加上。甲方说的「购物车在台式机的问题」很可能就是这个。
   原因：主题的 cart-drawer.js 渲染完会往 #cart-icon-bubble 里写新的购物车图标，
   而这个 id 只在原主题的页头（header.liquid）里有；改用 yonghui 页头后页面上没有它，
   写入时报 TypeError，后面的「打开抽屉」那一步就没执行。
   修法：页面上缺哪个 id 就补一个隐藏的空壳接住这次写入，抽屉照常弹出；
   另外抽屉一打开、或购物车有增减，就把页头的件数刷新一次（原来只有旧版商品模板会刷新它）。
   主题的 cart-drawer.js 不改。
   ========================================================================= */
(function(){
  var drawer = document.querySelector('cart-drawer');
  if(!drawer) return;
  ['cart-icon-bubble', 'cart-icon-bubble-sticky'].forEach(function(id){
    if(document.getElementById(id)) return;
    var sink = document.createElement('div');
    sink.id = id; sink.hidden = true; sink.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sink);
  });
  var busy = null;
  function refresh(){
    clearTimeout(busy);
    busy = setTimeout(function(){
      fetch('/cart.js', { credentials:'same-origin', headers:{ 'Accept':'application/json' } })
        .then(function(r){ return r.json(); })
        .then(function(c){
          document.querySelectorAll('[data-yh-cart-count]').forEach(function(el){ el.textContent = String(c.item_count); });
        }).catch(function(){});
    }, 120);
  }
  try {
    if(typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate){
      window.subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }
  } catch(e){}
  new MutationObserver(function(){ if(drawer.classList.contains('active')) refresh(); })
    .observe(drawer, { attributes:true, attributeFilter:['class'] });
})();

/* =========================================================================
   右侧「信号走线」= 全站滚动条（9/30 重做）
   用户 9/29：「（左边那条走线）和右边的那个滑动条合并一下，这个效果移动到右边……这个条在整个网站上是可以贯穿的」；
   9/30：「这个滑动条怎么这么丑？我之前不是让你按照原来的流动光的那个效果做吗？」
   9/29 只把系统滚动条涂成了橙色，没把走线本身搬过来。现在照原来那条走线（godiag-bx-fx.js 的 initBeam）做：
   细轨 + 随滚动点亮的一段 + 头上一颗发光珠子，贴在视口右边缘，每一页都有；系统滚动条在皮肤层藏掉。
   长相全在 godiag-dark-skin.liquid「右侧信号走线」那段，这里只算进度、处理拖动。
   有鼠标的设备：按住拖 = 拖滚动条，点一下 = 跳到那里；触屏只显示，不接管手势。
   不用 requestAnimationFrame 节流：直接在 scroll 里写两个样式值，够轻；也避开「不出帧的环境里 rAF 永远不回调」。
   ========================================================================= */
(function(){
  if(window.__gdRail) return; window.__gdRail = true;
  var doc = document.documentElement;
  var rail = document.createElement('div');
  rail.className = 'gd-rail';
  rail.setAttribute('aria-hidden', 'true');   // 纯视觉；键盘、读屏照常用浏览器自己的滚动
  rail.innerHTML = '<i class="gd-rail__track"></i><i class="gd-rail__lit"></i><i class="gd-rail__bead"></i>';
  document.body.appendChild(rail);
  var lit = rail.querySelector('.gd-rail__lit'), bead = rail.querySelector('.gd-rail__bead');
  function room(){ return doc.scrollHeight - window.innerHeight; }
  function paint(){
    var m = room();
    rail.classList.toggle('is-off', m < 40);          // 不用滚的短页面不出
    var p = Math.max(0, Math.min(1, (window.scrollY || doc.scrollTop) / Math.max(1, m)));
    lit.style.height = (p * 100) + '%';
    bead.style.top = (p * 100) + '%';
    // 1-2：珠子压在橙色区块（首屏 / COVERAGE / BY CATEGORY / SOCIAL）时换成深色，在橙底上才看得清。
    // 探测点＝珠子竖向中点、横向取视口右侧偏左（避开走线本身；走线 pointer-events:none 时也稳）。
    var by = bead.getBoundingClientRect();
    var probe = document.elementFromPoint(Math.max(0, window.innerWidth - 48), by.top + by.height / 2);
    rail.classList.toggle('is-on-accent', !!(probe && probe.closest && probe.closest('.bx-hero, .bx-jobs, .bx-social')));
    // 4-6：走线只走正文、别压页脚。页脚进视口时把走线下端收到页脚顶上方 10px；页脚不在视口就恢复 CSS 默认。
    // 用 inline !important 压过 dark-skin 里 .gd-rail{bottom:…!important} 的默认值；移除 inline 即恢复默认。
    // 认【真页脚】（深色链接块 / footer-group），不认正文里那条 <footer class="bx-cta"> CTA 带——走线要盖到 CTA、只在真页脚前停
    var ft = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('.yonghui-footer') || document.querySelector('.yonghui-footer, footer');
    if (ft) {
      var ftTop = ft.getBoundingClientRect().top;
      if (ftTop < window.innerHeight) rail.style.setProperty('bottom', Math.round(window.innerHeight - ftTop + 10) + 'px', 'important');
      else rail.style.removeProperty('bottom');
    }
  }
  window.addEventListener('scroll', paint, { passive:true });
  window.addEventListener('resize', paint, { passive:true });
  if('ResizeObserver' in window) new ResizeObserver(paint).observe(document.body);   // 懒加载、折叠展开会改页面高度
  paint();

  var drag = false;
  function jump(e){
    var r = rail.getBoundingClientRect();
    var p = Math.max(0, Math.min(1, (e.clientY - r.top) / Math.max(1, r.height)));
    window.scrollTo(0, p * Math.max(0, room()));
  }
  rail.addEventListener('pointerdown', function(e){
    if(e.pointerType !== 'mouse' || e.button !== 0) return;
    drag = true; rail.classList.add('is-drag');
    try { rail.setPointerCapture(e.pointerId); } catch(x){}
    jump(e); e.preventDefault();
  });
  rail.addEventListener('pointermove', function(e){ if(drag) jump(e); });
  function end(e){
    if(!drag) return; drag = false; rail.classList.remove('is-drag');
    try { rail.releasePointerCapture(e.pointerId); } catch(x){}
  }
  rail.addEventListener('pointerup', end);
  rail.addEventListener('pointercancel', end);
})();

/* 4-8（10/1 退回补修）：搜索页 Filters 之前靠 search.json 的 section 顺序提到最前，结果排到了面包屑/标题【上面】、偏高，
   而且搜索页没有 Sort、和分类页「两钮在标题下」不一致。
   根因：Filters 是独立 section，标题/搜索框/结果都在另一个 __main section 里，CSS 排不进它们中间（MainContent 是 block）。
   这里用 JS 把整段 Filters section 搬到结果网格 #ProductGridContainer 前面＝落到标题/搜索框下、结果上，和分类页一致。
   搜索页没有 Sort 配对，给 Filters 加 gd-filters-solo 类、CSS 让它占满宽（不留半宽空档）。 */
(function(){
  if (window.__gdSearchFilter) return; window.__gdSearchFilter = true;
  var filt = document.querySelector('.yh-sb-mobile-toggle');
  if (!filt) return;
  var filtSec = filt.closest('.shopify-section') || filt;
  // 必须是「Filters 和结果不在同一 section」的页（搜索页）才搬；分类页本就对、别动
  var grid = document.querySelector('#ProductGridContainer') || document.querySelector('.product-grid-container');
  if (!grid) return;
  var gridSec = grid.closest('.shopify-section');
  if (gridSec && filtSec !== gridSec && !gridSec.contains(filtSec)) {
    // 把 Filters 搬到结果网格前（标题/搜索框在网格前，所以这就是「标题下、结果上」）
    grid.parentNode.insertBefore(filtSec, grid);
    filt.classList.add('gd-filters-solo');   // 搜索页独个 Filters：CSS 占满宽
  }
})();

/* =========================================================================
   3-8（10/2 用户定稿：真·钉住 · 只缩不变暗）首屏交接 —— A 层：rAF 手写 scroll，只给首屏内容加 scale。
   · 立方体转面（gd-cube/preserve-3d/rotateX/棱光）早已整段撤除；19:xx 的「缩+暗」里的 veil 也在 10/2 去掉。
   · 为什么不用 CSS animation-timeline：iOS 26 才支持，她的用户大量在 iPhone 微信（WebKit）里打开，绝大多数拿不到。
     所以缩放用这段 rAF scroll 手写，手机桌面都能跑。B 层（纯 CSS sticky + 橙缝 + 下一块投影）在 godiag-bx.css，单独就成立。
   · reduced-motion 或缺任一元素＝直接不建，干净退回纯 B（首屏照常钉住、FEATURED 照常带橙缝压上来）。
   · 只写 .bx-hero-content 的 transform:scale——不缩整块 .bx-hero，橙底/照片始终满铺＝交接不露黑。
     origin 顶部（CSS 里已设 transform-origin:50% 0）：从顶往下缩、顶边不动。终值 scale 0.94（她点过的值，别改）。
   ========================================================================= */
(function(){
  if(window.__gdHeroShrink) return; window.__gdHeroShrink = true;
  if(matchMedia('(prefers-reduced-motion: reduce)').matches) return;   // 退回纯 B
  var hero    = document.querySelector('.bx-hero:not(.bx-cover)');
  var track   = hero && hero.closest('.shopify-section');              // B 层里这个 section 被拉成 180svh 的轨道
  var content = hero && hero.querySelector('.bx-hero-content');
  if(!hero || !track || !content) return;                             // 缺任何一个＝退回纯 B
  var ticking = false;
  function paint(){
    ticking = false;
    var travel = track.offsetHeight - window.innerHeight;             // 钉住行程 = 轨道高 − 一屏
    if(travel <= 0){ content.style.transform = ''; return; }          // 轨道没比视口高（异常）＝不缩
    var p = Math.min(1, Math.max(0, -track.getBoundingClientRect().top / travel));
    content.style.transform = 'scale(' + (1 - 0.06 * p).toFixed(4) + ')';   // 1 → 0.94，p 对到整段钉住行程
  }
  addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(paint); } }, { passive:true });
  addEventListener('resize', paint, { passive:true });
  paint();
})();

/* =========================================================================
   2-4（10/2 用户 iPhone 实测）：悬浮球（WhatsApp .yh-fab / Inbox Chat）在首页/分类/商品页压产品内容。
   按她给的「滚动时半透让开」：手机上滚动时给 <html> 加 .gd-fab-dim（样式在 dark-skin：球淡到 .16 + pointer-events:none），
   停手 ~260ms 去掉＝球恢复。球始终在、随时能点，只是滚动看内容时让开。只动 class/opacity，不动球的位置（不碰 3-9 叠放）。
   仅手机档跑；rAF 节流。购物车页球本就整颗收起（html:has(.cart__footer)），不受影响。
   ========================================================================= */
(function(){
  if(window.__gdFabDim) return; window.__gdFabDim = true;
  var root = document.documentElement, mq = matchMedia('(max-width:760px)');
  var t = 0, ticking = false;
  function tick(){
    ticking = false;
    if(!mq.matches){ root.classList.remove('gd-fab-dim'); return; }
    if(!root.classList.contains('gd-fab-dim')) root.classList.add('gd-fab-dim');
    clearTimeout(t);
    t = setTimeout(function(){ root.classList.remove('gd-fab-dim'); }, 260);
  }
  addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(tick); } }, { passive:true });
})();

/* =========================================================================
   9/30 夜 · 页头 + 跑马灯常驻顶部（用户：「顶部导航栏和跑马灯应该一直固定在顶部才对，怎么滑动就不见了？」）
   做法：两个 section 外壳留在文档流里当占位（高度 = 各自内容的原高），里面的 .bx-mq / .yh 改成 position:fixed。
   不用 position:sticky——抽屉、筛选打开时主题会给 body 加 overflow:hidden，body 一变成滚动容器，
   sticky 的参照就换了，页头会在抽屉背后跳走；fixed 不受影响。
   手机上页头有两行（logo 行 + 搜索行，107px），滚过页头原位以后搜索行收起（.gd-compact），只留 logo 行；
   占位壳高度不变，所以收起时正文不跳。底栏里有搜索，回到顶部搜索行自己回来。
   量出来的几个高度写成变量：--gd-mq-h（跑马灯）、--gd-head-h（跑马灯 + 页头当前高度）——
   右侧走线、锚点跳转（scroll-padding）、详情页 / 分类页的吸顶栏都按它让位。样式在 dark-skin「页头常驻」一段。
   ========================================================================= */
(function(){
  if(window.__gdHead) return; window.__gdHead = true;
  var root = document.documentElement;
  var mqSec = document.querySelector('.shopify-section.section-bx-marquee');
  var hdSec = document.querySelector('.shopify-section.section-yonghui-header');
  var yh = hdSec && hdSec.querySelector('.yh');
  if(!yh) return;
  var mq = mqSec && mqSec.querySelector('.bx-mq');
  // 收起：手机（≤768）收掉搜索行；两行页头的宽度（769–1249，你常用的 1000 宽就在这一档）两行各压矮一点。1250 以上本来就是一行，不收。
  var mobile = window.matchMedia('(max-width: 1249px)');
  var fullH = 0;
  // 不能用 offsetParent 判断显隐：改成 fixed 以后 offsetParent 永远是 null，会量成 0、页头顶到跑马灯上（9/30 夜实测）
  function mqH(){ return mq ? mq.offsetHeight : 0; }
  function measure(){
    // 量「展开态」的页头高：收起态时临时摘掉类名再量（同一帧内，不会闪）
    var compact = root.classList.contains('gd-compact');
    if(compact) root.classList.remove('gd-compact');
    var m = mqH(); fullH = yh.offsetHeight;
    if(compact) root.classList.add('gd-compact');
    if(mqSec) mqSec.style.height = m + 'px';
    hdSec.style.height = fullH + 'px';
    root.style.setProperty('--gd-mq-h', m + 'px');
    setHeadVar();
  }
  function setHeadVar(){ root.style.setProperty('--gd-head-h', (mqH() + yh.offsetHeight) + 'px'); }
  var lastCompact = null;
  function onScroll(){
    var y = window.scrollY || root.scrollTop;
    // 收起阈值：滚过页头原位（再多 40px）才收；回到 60px 以内展开——两个阈值错开，停在边界上不会来回抖
    var c = mobile.matches && (lastCompact ? y > 60 : y > fullH + 40);
    if(c !== lastCompact){ lastCompact = c; root.classList.toggle('gd-compact', c); setHeadVar(); }
  }
  measure();
  root.classList.add('gd-fixed-head');
  onScroll();
  window.addEventListener('scroll', onScroll, { passive:true });
  window.addEventListener('resize', function(){ measure(); onScroll(); }, { passive:true });
  if('ResizeObserver' in window){
    var ro = new ResizeObserver(function(){ if(!root.classList.contains('gd-compact')) measure(); else setHeadVar(); });
    ro.observe(yh); if(mq) ro.observe(mq);
  }
  // 字体晚到会改行高：load 之后再量一次
  window.addEventListener('load', measure);
})();

/* =========================================================================
   9/30 夜 · 页头下拉「一次只开一个」（用户截图：SHOP BY BRAND 和 SHOP BY CATEGORY 两个菜单叠在一起）
   原因：原主题的下拉靠 :hover 和 :focus-within 两条开。用鼠标点过一个菜单标题（它有 tabindex，会拿到焦点），
   鼠标移开后 :focus-within 还成立，它就一直开着；再悬停下一个，两个叠在一起。
   样式那边把「只是被鼠标点过」的焦点排除在外（只认键盘的 :focus-visible）；这里再补一刀：
   鼠标离开菜单项时，焦点如果还留在里面，就放掉。键盘用户不受影响（Tab 进去照样展开）。
   ========================================================================= */
(function(){
  var items = document.querySelectorAll('.yh-nav__item');
  if(!items.length) return;
  var byMouse = false;
  document.addEventListener('pointerdown', function(e){ byMouse = e.pointerType === 'mouse'; }, true);
  document.addEventListener('keydown', function(e){ if(e.key === 'Tab') byMouse = false; }, true);
  items.forEach(function(li){
    li.addEventListener('mouseleave', function(){
      var a = document.activeElement;
      if(byMouse && a && li.contains(a) && a !== document.body && typeof a.blur === 'function') a.blur();
    });
  });
})();

/* =========================================================================
   9/30 夜 · 卡片扫光：给每张能点的卡片插一个 <i class="gd-sheen">（样式在 dark-skin「卡片扫光」）
   用真实子元素而不是卡片的 ::before / ::after——9/07 那次「卡片光标高光」就是抢了 .bx-route::after，
   把悬停的橙色填充顶掉、字压在深底上看不见，被甲方退掉（见 godiag-bx-fx.js 的说明）。
   分类页筛选、收藏页是脚本后渲染的卡片，用 MutationObserver 补插。
   ========================================================================= */
(function(){
  if(window.__gdSheen) return; window.__gdSheen = true;
  var SEL = '.bx-route, .bx-shop-card, .bx-product, .bx-brand, .bx-download-type, .bx-kit, .bx-social-row, .bx-trust-card, .bx-five-card, .yhpc, .yh-wl-card, .yh-cl__card, .yh-dl__card';
  function arm(c){
    if(c.querySelector(':scope > .gd-sheen')) return;
    if(getComputedStyle(c).position === 'static') c.style.position = 'relative';
    var i = document.createElement('i'); i.className = 'gd-sheen'; i.setAttribute('aria-hidden', 'true');
    c.appendChild(i);
  }
  function scan(root){
    if(!root || root.nodeType !== 1) return;
    if(root.matches && root.matches(SEL)) arm(root);
    root.querySelectorAll(SEL).forEach(arm);
  }
  scan(document.body);
  new MutationObserver(function(ms){
    ms.forEach(function(m){ m.addedNodes.forEach(function(n){ if(n.nodeType === 1 && !(n.classList && n.classList.contains('gd-sheen'))) scan(n); }); });
  }).observe(document.body, { childList:true, subtree:true });
})();

/* =========================================================================
   9/30 夜 · 手机「Sort」抽屉（样式在 dark-skin ⑩：改成底部升起的面板、压在页头之上、背后压暗）
   原主题的 × 在 Sort 按钮（summary）里、贴视口右上角——被常驻页头压住；原主题接「点外面关闭」的那层透明遮罩也在页头之下。
   这里：面板标题栏里补一颗关闭键；点背后压暗的地方也关。两者都是去点 summary——走原主题自己的关闭动画和逻辑。
   筛选区会被 AJAX 整块重画，所以每次打开（toggle 事件）时再检查一遍有没有那颗键。
   ========================================================================= */
(function(){
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function closeIt(d){ var s = d && d.querySelector(':scope > summary'); if(s) s.click(); }
  document.addEventListener('toggle', function(e){
    var d = e.target;
    if(!d || !d.classList || !d.classList.contains('mobile-facets__disclosure') || !d.open) return;
    var h = d.querySelector('.mobile-facets__header');
    if(h && !h.querySelector('.gd-sheet-close')){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'gd-sheet-close'; b.setAttribute('aria-label', 'Close'); b.innerHTML = X;
      h.appendChild(b);
    }
  }, true);
  document.addEventListener('click', function(e){
    var t = e.target; if(!t || !t.closest) return;
    var b = t.closest('.gd-sheet-close');
    if(b){ e.preventDefault(); e.stopPropagation(); closeIt(b.closest('details[open]')); return; }
    if(t.classList && t.classList.contains('mobile-facets')){ e.preventDefault(); closeIt(t.closest('details[open]')); }
  }, true);
})();

/* =========================================================================
   9/30 深夜 · FEATURED「往下滚 = 商品往左走，走完才继续往下」
   用户：「用户向下滑动的时候会让这个产品往左边滑动，等所有的产品都展示完成，无法再向左滑动的时候，才可以向下滑动吗？
   参考……jingyilab.vercel.app/tasteprint 这个模块的交互逻辑」
   那个页面的做法（实测）：外层拉高（3878px）、里面一层 position:sticky 贴顶（689px 高、内容 4370px 宽），
   往下滚的距离换算成横向位移——横向走完的同时外层也到底，页面才接着往下。这里照同一个结构：
     · 外层 = section.bx-featured，高度 = 里层高度 + 横向要走的距离；
     · 里层 = .bx-shell，贴在页头下面；
     · 横向位移直接写轮播自己的 scrollLeft——原来的左右箭头、01–06 计数、扫光都照常联动。
   只在 ≥900px、没开「减少动态效果」时启用；手机保留手指横滑（手机上把竖滑劫持成横滑，会和系统的滑动手势打架）。
   左右箭头：变成「把页面滚到下一张 / 上一张对应的位置」；触控板横向滑动也换算成往下 / 往上滚。
   大屏整页放大（html zoom）时，矩形是放大后的像素、高度 / scrollLeft 是放大前的——统一换到矩形单位算比例。
   ========================================================================= */
(function(){
  var sec = document.querySelector('.bx-featured');
  var shell = sec && sec.querySelector(':scope > .bx-shell');
  var grid = sec && sec.querySelector('.bx-product-grid');
  if(!sec || !shell || !grid) return;
  var root = document.documentElement;
  var mq = window.matchMedia('(min-width: 900px) and (prefers-reduced-motion: no-preference)');
  var on = false, dist = 0, raf = 0;
  function Z(){ return parseFloat(root.style.zoom) || 1; }
  function headH(){ return parseFloat(getComputedStyle(root).getPropertyValue('--gd-head-h')) || 0; }
  function padT(){ return parseFloat(getComputedStyle(sec).paddingTop) || 0; }
  function span(){ return Math.max(1, dist); }       // 贴顶以后能走的竖向距离 = 横向要走的距离（放大前的 px）
  function progress(){
    var r = sec.getBoundingClientRect();              // 里层开始贴顶 = 外层顶 + 上内边距 到达「页头下沿 + 8」
    return Math.min(1, Math.max(0, ((headH() + 8) * Z() - (r.top + padT() * Z())) / (span() * Z())));
  }
  function update(){ raf = 0; if(on) grid.scrollLeft = Math.round(progress() * dist); }
  function setup(){
    sec.classList.remove('gd-hpin'); sec.style.height = ''; on = false;
    if(!mq.matches) return;
    sec.classList.add('gd-hpin');
    dist = Math.max(0, grid.scrollWidth - grid.clientWidth);
    if(dist < 40){ sec.classList.remove('gd-hpin'); return; }
    var cs = getComputedStyle(sec), pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    sec.style.height = (shell.offsetHeight + dist + (cs.boxSizing === 'border-box' ? pad : 0)) + 'px';
    on = true; update();
  }
  function scrollPageBy(dLeft){           // 横向要多走 dLeft → 页面要多滚多少
    window.scrollBy({ top: dLeft / dist * span(), behavior:'smooth' });
  }
  // 不走 requestAnimationFrame：有的环境里它不触发（见 godiag-bx.css 首屏视差那段说明）；滚动事件本来就是每帧最多一次
  addEventListener('scroll', function(){ if(on) update(); }, { passive:true });
  addEventListener('resize', function(){ clearTimeout(setup.t); setup.t = setTimeout(setup, 150); });
  if(mq.addEventListener) mq.addEventListener('change', setup);
  addEventListener('load', setup);
  // 箭头：捕获阶段接住，原来的「轮播横滚一格」不再执行
  sec.addEventListener('click', function(e){
    if(!on) return;
    var a = e.target.closest && e.target.closest('.bx-shop-arrow'); if(!a) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var card = grid.children[0], gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
    var step = card ? card.getBoundingClientRect().width / Z() + gap : grid.clientWidth * .8;
    var dir = a.hasAttribute('data-bx-prev') ? -1 : 1;
    var target = Math.min(dist, Math.max(0, Math.round((grid.scrollLeft + dir * step) / step) * step));
    scrollPageBy(target - grid.scrollLeft);
  }, true);
  // 触控板横滑：换算成竖滚
  grid.addEventListener('wheel', function(e){
    if(!on || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault(); window.scrollBy(0, e.deltaX / dist * span());
  }, { passive:false });
  setup();
})();

/* =========================================================================
   9/30 深夜 · 三步流程依次出现（样式在 godiag-bx.css「DOES IT DO 三步：依次出现」）
   加 .gd-steps = 先藏好；进入屏幕 35% 时加 .gd-play = 开始播，只播一次。没有 IntersectionObserver / 减少动态效果：什么都不加，直接是成品。
   ========================================================================= */
(function(){
  var s = document.querySelector('.bx-cover-steps');
  if(!s || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  s.classList.add('gd-steps');
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ s.classList.add('gd-play'); io.disconnect(); } });
  }, { threshold:.35 });
  io.observe(s);
})();

/* =========================================================================
   9/30 深夜 · 手机滚动入场：标题、卡片进入屏幕时上浮淡入，同一排依次出现（样式在 godiag-bx.css「滚动入场」）
   用户：「上下滑动的时候元素出来需要有一些动效，目前都太呆板了」。
   横滑轨道里的卡片：rootMargin 左右放宽，竖向到了就算进屏（否则横向没露出来的那几张永远不出现）。
   只在 ≤760px、没开「减少动态效果」时；已经在屏幕里的第一屏元素不藏（避免打开页面先空一下）。
   ========================================================================= */
(function(){
  var mq = window.matchMedia('(max-width: 760px) and (prefers-reduced-motion: no-preference)');
  if(!mq.matches || !('IntersectionObserver' in window)) return;
  var SEL = '.bx-main .bx-section-head, .bx-main .bx-title, .bx-cover .bx-cover-title, .bx-product, .bx-shop-card, .bx-job, .bx-brand, .bx-download-type,'
          + ' .bx-social-row, .bx-five-card, .bx-trust-card, .bx-cta h2, .yhpc, .collection-list > .grid__item, .yh-dl__card, .yh-cl__card, .pdd__block, .pdd__sec';
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('gd-in'); io.unobserve(e.target); } });
  }, { rootMargin:'0px 1200px -6% 1200px', threshold:.12 });
  var seen = new WeakSet();
  function arm(root){
    var vh = window.innerHeight;
    (root || document).querySelectorAll(SEL).forEach(function(el){
      if(seen.has(el)) return; seen.add(el);
      var r = el.getBoundingClientRect();
      if(r.top < vh * .92 && r.bottom > 0) return;                 // 第一屏里的不藏
      var p = el.parentElement, i = p ? Array.prototype.indexOf.call(p.children, el) : 0;
      el.style.setProperty('--gd-rv-d', ((i % 4) * 70) + 'ms');
      el.classList.add('gd-rv'); io.observe(el);
    });
  }
  arm();
  // 分类页筛选 / 翻页是脚本重画的：新卡片补上
  new MutationObserver(function(ms){ ms.forEach(function(m){ m.addedNodes.forEach(function(n){ if(n.nodeType === 1) arm(n.parentElement || n); }); }); })
    .observe(document.querySelector('main') || document.body, { childList:true, subtree:true });
})();

/* =========================================================================
   9/30 深夜 · 手机分类页工具条：Sort 对齐到 Filters 那一行（样式在 godiag-bx-pages.css 末尾）
   原来靠 CSS「往上拉 52px」——Filters 和 Sort 在上下两个 section 里，中间要是多一块、或者行高不一样，就对不上
   （后来为收藏页加的保护规则还把这个上拉整个关掉了，Sort 掉到下一行，用户截图就是这样）。改成量出来差多少就拉多少；
   两颗之间隔着别的内容（差距 > 90px）就不拉。
   ========================================================================= */
(function(){
  var mq = window.matchMedia('(max-width: 760px)');
  function align(){
    var f = document.querySelector('.yh-sb-mobile-toggle'), sec = document.querySelector('#main-collection-filters');
    var s = sec && sec.querySelector('.mobile-facets__open-wrapper');
    if(!sec) return;
    sec.style.removeProperty('margin-top');
    if(!mq.matches || !f || !s || !f.offsetParent || !s.offsetParent) return;
    var d = s.getBoundingClientRect().top - f.getBoundingClientRect().top;
    if(d <= 0 || d > 90) return;
    var m = parseFloat(getComputedStyle(sec).marginTop) || 0;
    sec.style.setProperty('margin-top', (m - d) + 'px', 'important');
  }
  align(); addEventListener('load', align); addEventListener('resize', function(){ clearTimeout(align.t); align.t = setTimeout(align, 150); });
  document.addEventListener('shopify:section:load', align);
  var grid = document.getElementById('ProductGridContainer');
  if(grid) new MutationObserver(function(){ clearTimeout(align.m); align.m = setTimeout(align, 120); }).observe(grid, { childList:true });
})();

/* =========================================================================
   9/30 深夜 · 横滑轨道：电脑上用鼠标按住拖动（热销那排、平板上的 FEATURED）
   用户：「这个只能自动播放不能手动滑动诶，需要也可以手动滑动才对」。触控板 / 手指本来就能横滑（自动漂移那边也改成一碰就停，见 godiag-bx.js）；
   鼠标没有横滑，浏览器也不支持拖动滚动条以外的地方——这里补上：按住拖，松手后顺滑吸到最近一张卡；拖过的那一下不会误点进商品。
   ========================================================================= */
(function(){
  function enable(rail){
    if(rail.__gdDrag) return; rail.__gdDrag = true;
    var d = null, suppress = false;
    rail.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0) return;
      if(rail.closest('.gd-hpin')) return;                       // FEATURED 固定横移时由竖滚驱动
      d = { x:e.clientX, sl:rail.scrollLeft, moved:false };
    });
    window.addEventListener('pointermove', function(e){
      if(!d) return;
      var dx = e.clientX - d.x;
      if(!d.moved && Math.abs(dx) > 5){ d.moved = true; rail.classList.add('gd-dragging'); rail.dataset.bxDrift = 'on'; }   // 拖动期间关掉吸附，不然一格一格跳
      if(d.moved){ rail.scrollLeft = d.sl - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function(){
      if(!d) return;
      var moved = d.moved; d = null;
      if(!moved) return;
      suppress = true; setTimeout(function(){ suppress = false; }, 60);
      rail.classList.remove('gd-dragging');
      // 顺滑吸到最近一张卡的左边，再还回吸附
      var items = rail.children, best = 0, dist = 1e9, left = rail.getBoundingClientRect().left;
      for(var i = 0; i < items.length; i++){ if(items[i].hidden) continue; var dd = Math.abs(items[i].getBoundingClientRect().left - left); if(dd < dist){ dist = dd; best = i; } }
      var target = items[best] ? rail.scrollLeft + items[best].getBoundingClientRect().left - left : rail.scrollLeft;
      rail.scrollTo({ left:target, behavior:'smooth' });
      setTimeout(function(){ delete rail.dataset.bxDrift; }, 450);
    });
    rail.addEventListener('click', function(e){ if(suppress){ e.preventDefault(); e.stopPropagation(); } }, true);
    rail.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }
  function scan(){ document.querySelectorAll('.bx-shop-rail, .bx-featured .bx-product-grid').forEach(enable); }
  scan(); addEventListener('load', scan);
})();

/* =========================================================================
   页脚进场（10-02 她定的页脚动效第 ③ 样，样式在 godiag-dark-skin.liquid「页脚交互动效」）
   页脚滚进视口时，各列逐列淡入上移。悬停那两样（链接下划线、社交图标）是纯 CSS、包在
   @media(hover:hover) 里，不用 JS。

   做法：先给 .yonghui-footer 加 .gd-farm（＝预埋，CSS 这时才把各列藏起来），再在进视口时加 .gd-fin 播放。
   预埋类由 JS 加而不是写死在 CSS 里：JS 没跑、或者整段没装时，页脚就是常态直接可见，
   绝不会留一片空白（和 gd-rv 入场同一套退路写法）。「减少动态效果」时整段不装。

   ⚠️ 藏起来之后必须保证一定能放出来——【页脚永远不显示】是绝不能出的事故。
   实测踩到：后台标签 / 窗口不可见时浏览器会把 IntersectionObserver 连同 rAF 一起节流，
   连首次回调都不发，页脚就永远停在 opacity:0。所以这里铺了三条路，谁先到算谁：
     ① IntersectionObserver（正常情况走这条）
     ② 滚动时自己按 getBoundingClientRect 算（IO 不回调也能放出来）
     ③ 不管发生什么，6 秒后无条件显示
   另外进来就先判一次「是不是已经在视口里」，是就直接播、根本不藏。
   ========================================================================= */
(function(){
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var f = null, shown = false;
  function show(){ if(shown || !f) return; shown = true; f.classList.add('gd-fin'); }
  function inView(){
    var r = f.getBoundingClientRect();
    return r.top < window.innerHeight * 0.96 && r.bottom > 0;
  }
  function arm(){
    if(f) return;
    f = document.querySelector('footer .yonghui-footer, .yonghui-footer');
    if(!f) return;
    f.classList.add('gd-farm');
    if(inView()){ show(); return; }                      /* 已经看得见：直接播，不先藏 */

    /* 主路：IntersectionObserver */
    if('IntersectionObserver' in window){
      try {
        var io = new IntersectionObserver(function(es){
          for(var i = 0; i < es.length; i++) if(es[i].isIntersecting){ show(); io.disconnect(); return; }
        }, { threshold:.1, rootMargin:'0px 0px -4% 0px' });
        io.observe(f);
      } catch(e){}
    }
    /* 兜底一：自己按滚动量算（IO 在后台标签 / 被节流 / 实现有坑时根本不回调——
       那会让页脚永远停在 opacity:0，这是绝不能出的事故） */
    var tick = null;
    function onScroll(){
      if(shown){ removeEventListener('scroll', onScroll); return; }
      if(tick) return;
      tick = requestAnimationFrame(function(){ tick = null; if(inView()) show(); });
    }
    addEventListener('scroll', onScroll, { passive:true });
    addEventListener('resize', onScroll);
    /* 兜底二：无论如何 6 秒后一定显示出来 */
    setTimeout(show, 6000);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
  addEventListener('load', arm);
})();

/* =========================================================================
   1-6（10-02）· 触屏悬停残留：最后一道兜底（只在没有鼠标的设备上跑）

   背景：B 层（godiag-bx.css / godiag-bx-pages.css / godiag-dark-skin.liquid）里散落的 :hover
   这一轮已经全部并进 @media(hover:hover)，触屏上不再命中。但 **A 版各 section 自带的裸 :hover
   改不了**（yonghui-wishlist / yonghui-downloads / yonghui-collection-list / yonghui-contact-popup /
   yonghui-collection-tagbar … 共约 57 条，都是甲方原文件，按规矩不动）。
   实测（预览上把 hover:hover 段排除掉再跑级联）：B 层一收进媒体查询，这些 A 版规则在触屏上就**反而赢了**——
   例如点一下收藏页卡片标题会留旧橙 #FF6B1C、卡片上浮 4px，收藏心会变成白底。
   也就是说只改 B 层并不能真的收干净，必须再补这一道。

   做法：触屏设备上，把**同源样式表里所有没被 @media(hover:hover) 包住的 :hover 规则**改写掉——
   不是删规则（删了索引会错位、也会误伤同一条里的别的状态），而是改 selectorText：
     · 选择器列表里带 :hover 的那一项去掉，不带的（.is-on / :focus-visible / [aria-selected] …）原样留着；
     · :is(:hover, :focus-within) 这种只摘掉 :hover、留 :focus-within——分类页 Sort 下拉在触屏上
       就是靠 :focus-within 展开的（4-5），不能连它一起摘；
     · :not(:hover) 整个去掉——它是「常态」规则，触屏挂住 :hover 以后反而会失效（卡片字色跳一下）；
     · 整条都只剩 :hover 的，把选择器换成一个谁也不匹配的类名，等于让它失效。
   ⚠️ 导航（yh-nav__ / yh-mega / yh-dropdown）整段跳过：平板上菜单是靠 :hover 展开的，摘了就打不开。
   取不到 cssRules 的（跨域表、插件 iframe）直接跳过，任何一条改写失败就原样放着，不影响页面。
   JS 没跑 = 维持现状（和这一轮之前一样），不会把页面搞坏。
   ========================================================================= */
(function(){
  if(!window.matchMedia || !matchMedia('(hover:none)').matches) return;
  var SKIP = /yh-nav__|yh-mega|yh-dropdown/;          /* 导航：靠 :hover 展开，别动 */
  var DEAD = '.gd-hover-off-never-matches';            /* 谁也不匹配的占位类 */

  function splitTop(s){                                /* 只按最外层的逗号切，括号里的不算 */
    var out = [], d = 0, cur = '';
    for(var i = 0; i < s.length; i++){
      var ch = s[i];
      if(ch === '(' || ch === '[') d++;
      else if(ch === ')' || ch === ']') d--;
      if(ch === ',' && d === 0){ out.push(cur); cur = ''; } else cur += ch;
    }
    out.push(cur);
    return out.map(function(x){ return x.trim(); }).filter(Boolean);
  }
  /* 把 :is(…)/:where(…) 里的 :hover 摘掉，其余项留着 */
  function pullFromIs(part){
    var re = /:(is|where)\(/g, m;
    while((m = re.exec(part))){
      var open = m.index + m[0].length - 1, d = 0, j = open;
      for(; j < part.length; j++){
        if(part[j] === '(') d++;
        else if(part[j] === ')'){ d--; if(!d) break; }
      }
      var items = splitTop(part.slice(open + 1, j));
      if(items.indexOf(':hover') === -1) continue;
      var rest = items.filter(function(x){ return x !== ':hover'; });
      if(!rest.length) return null;                    /* :is(:hover) 单独一项 → 整项作废 */
      return part.slice(0, m.index) + ':' + m[1] + '(' + rest.join(', ') + ')' + part.slice(j + 1);
    }
    return part;
  }
  function rewrite(sel){
    var kept = [];
    splitTop(sel).forEach(function(part){
      part = part.split(':not(:hover)').join('');      /* 常态规则：去掉 :not(:hover)，触屏上一直成立 */
      if(part.indexOf(':hover') !== -1){
        var p = pullFromIs(part);
        if(p === null) return;                         /* 整项作废 */
        part = p;
      }
      if(part.indexOf(':hover') !== -1) return;        /* 直接挂在元素上的 :hover：整项丢掉 */
      if(part.trim()) kept.push(part.trim());
    });
    return kept.length ? kept.join(', ') : DEAD;
  }

  function walk(rules){
    for(var i = 0; i < rules.length; i++){
      var r = rules[i], sel = r.selectorText;
      /* ⚠️ 不能用「有没有 .cssRules」来判断是不是分组规则：支持 CSS 嵌套的引擎上
         普通样式规则也带一个空的 .cssRules（真机踩到过，整个清扫一条都没执行）。
         判据改成「有没有 selectorText」：@media/@supports/@layer 没有，样式规则一定有。 */
      if(sel === undefined){                           /* @media / @supports / @layer / @keyframes */
        if(!r.cssRules) continue;
        var q = (r.conditionText || (r.media && r.media.mediaText) || '').replace(/\s/g, '');
        if(q.indexOf('hover:hover') !== -1 || q.indexOf('hover:none') !== -1) continue;  /* 已经分过设备的，不碰 */
        try { walk(r.cssRules); } catch(e){}
        continue;
      }
      if(sel && sel.indexOf(':hover') !== -1 && !SKIP.test(sel)){
        try { var n = rewrite(sel); if(n !== sel) r.selectorText = n; } catch(e){}
      }
      if(r.cssRules && r.cssRules.length){ try { walk(r.cssRules); } catch(e){} }   /* 嵌套 CSS */
    }
  }
  function sweep(){
    for(var i = 0; i < document.styleSheets.length; i++){
      var s = document.styleSheets[i], rules;
      if(s.dataset && s.dataset.gdHoverSwept) continue;
      try { rules = s.cssRules; } catch(e){ continue; }   /* 跨域表读不到，跳过 */
      if(!rules) continue;
      try { walk(rules); } catch(e){}
      try { if(s.ownerNode && s.ownerNode.dataset) s.ownerNode.dataset.gdHoverSwept = '1'; } catch(e){}
    }
  }
  sweep();
  addEventListener('load', sweep);
  /* 插件和 AJAX 片段会后补 <style>/<link>，补一次扫一次（节流） */
  var t = null;
  new MutationObserver(function(ms){
    for(var i = 0; i < ms.length; i++){
      for(var j = 0; j < ms[i].addedNodes.length; j++){
        var n = ms[i].addedNodes[j];
        if(n.nodeType === 1 && (n.tagName === 'STYLE' || n.tagName === 'LINK')){
          clearTimeout(t); t = setTimeout(sweep, 120); return;
        }
      }
    }
  }).observe(document.documentElement, { childList:true, subtree:true });
})();
